var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7183 42.2355H10.5176V40.9805H32.7183V42.2355Z",
    fill: "#53D0A4",
    stroke: "#53D0A4",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7183 33.3449H10.5176V32.0898H32.7183V33.3449Z",
    fill: "#53D0A4",
    stroke: "#53D0A4",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7183 24.4797H10.5176V23.2246H32.7183V24.4797Z",
    fill: "#53D0A4",
    stroke: "#53D0A4",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.334H42.2351V46.0504C42.2408 47.0614 42.645 48.0294 43.3599 48.7444C44.0752 49.4597 45.044 49.8639 46.0556 49.8692L46.0524 51.1243H6.07235L6.06909 51.1242C4.72684 51.1173 3.44154 50.581 2.49241 49.6318C1.54328 48.6827 1.00698 47.3974 1.00001 46.0552L1 46.0519V14.334ZM2.25508 15.5891V46.0502C2.26074 47.0613 2.6649 48.0294 3.37989 48.7444C4.09492 49.4594 5.0631 49.8636 6.07427 49.8692H42.7265C42.6394 49.7932 42.5546 49.7141 42.4724 49.6318C41.5233 48.6827 40.987 47.3974 40.98 46.0552L40.98 46.0519V15.5891H2.25508Z",
    fill: "#53D0A4",
    stroke: "#53D0A4",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89062 1H32.9828L37.3345 5.44481H51.1257V46.0524C51.1257 47.3976 50.5913 48.6878 49.6401 49.639C48.6888 50.5903 47.3986 51.1247 46.0534 51.1247C44.7081 51.1247 43.4179 50.5903 42.4667 49.639C41.5154 48.6878 40.981 47.3976 40.981 46.0524V15.5895H9.89062V1ZM11.1457 2.25508V14.3344H42.2361V46.0524C42.2361 47.0648 42.6383 48.0357 43.3541 48.7516C44.07 49.4674 45.041 49.8696 46.0534 49.8696C47.0658 49.8696 48.0367 49.4674 48.7526 48.7516C49.4685 48.0357 49.8706 47.0648 49.8706 46.0524V6.69989H36.8068L32.4551 2.25508H11.1457Z",
    fill: "#53D0A4",
    stroke: "#53D0A4",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.fbee660bb04fa8341646732ea9df3ee2.svg";
export { ForwardRef as ReactComponent };